export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.4.2-1240.23",
  commitId: "b4888ef889495a608d79cef278a007a6be8ad815",
  commitTime: "2026-04-02T12:40:23.000Z",
});
